// extracted by mini-css-extract-plugin
export default {"customerForm":"CustomerForm_customerForm__DNx-1"};